type KeyType = PropertyKey | Record<string | number, unknown> | Array<unknown>;

export class ConfigStorage {
  static buildKey(key: KeyType): string {
    let configsKey: string;

    if (typeof key === 'object') {
      configsKey = JSON.stringify(key);
    } else {
      configsKey = key.toString();
    }

    return configsKey;
  }

  static setConfigs(key: KeyType, value: unknown): string {
    const configsValue = JSON.stringify(value);
    const configsKey = ConfigStorage.buildKey(key);

    localStorage.setItem(configsKey, configsValue);

    return configsKey;
  }

  static getConfigs<T = unknown>(key: KeyType): T | undefined {
    const item = localStorage.getItem(ConfigStorage.buildKey(key));

    if (!item) {
      return undefined;
    }

    return JSON.parse(item) as T;
  }

  static deleteConfigs(key: KeyType): void {
    localStorage.removeItem(ConfigStorage.buildKey(key));
  }
}
